export const convertFileToBase64 = (blob: Blob) => {
  return new Promise(resolve => {
    const reader = new FileReader();
    reader.onload = function onload(event) {
      const res = event.target?.result;
      if (typeof res === 'string') {
        resolve(res.replace('data:', '').replace(/^.+,/, ''));
      }
    };
    reader.readAsDataURL(blob);
  });
};
